import { render, staticRenderFns } from "./TopUpForm.vue?vue&type=template&id=88a67ed2&scoped=true&"
import script from "./TopUpForm.vue?vue&type=script&lang=js&"
export * from "./TopUpForm.vue?vue&type=script&lang=js&"
import style0 from "./TopUpForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TopUpForm.vue?vue&type=style&index=1&id=88a67ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a67ed2",
  null
  
)

export default component.exports